module.exports = __webpack_public_path__ + "img/freekassa.13145424.png";